<template><div v-if="Object.keys(errors).length" class="alert alert-danger py-2" role="alert">Revise os campos destacados para prosseguir ({{ Object.keys(errors).length }} pendência(s)).</div></template>
<script>
export default { name: 'ValidationSummary', props: { errors: { type: Object, default: () => ({}) } } }
</script>
